import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=d0e823dc&scoped=true"
import script from "./BookingDetails.vue?vue&type=script&lang=js"
export * from "./BookingDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingDetails.vue?vue&type=style&index=0&id=d0e823dc&prod&lang=scss"
import style1 from "./BookingDetails.vue?vue&type=style&index=1&id=d0e823dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e823dc",
  null
  
)

export default component.exports